// Shared display metadata for campaign + recipient statuses. Badge names map
// onto the .badge variants in freightsource.css — no new colours invented.

export const STATUS_META = {
    draft: { label: 'draft', badge: 'cold' },
    ready: { label: 'ready', badge: 'warm' },
    sending: { label: 'sending', badge: 'hot' },
    sent: { label: 'sent', badge: 'success' },
    failed: { label: 'failed', badge: 'warm' },
    cancelled: { label: 'cancelled', badge: 'ink' },
};

export const RECIPIENT_STATUS_META = {
    pending: { label: 'pending', badge: 'cold' },
    sending: { label: 'sending', badge: 'hot' },
    sent: { label: 'sent', badge: 'ink' },
    delivered: { label: 'delivered', badge: 'success' },
    opened: { label: 'opened', badge: 'success' },
    bounced: { label: 'bounced', badge: 'warm' },
    dropped: { label: 'dropped', badge: 'warm' },
    spam: { label: 'spam', badge: 'warm' },
    failed: { label: 'failed', badge: 'warm' },
    skipped: { label: 'skipped', badge: 'cold' },
};

const EMPTY_TOTALS = {
    recipients: 0, pending: 0, sent: 0, delivered: 0,
    opened: 0, bounced: 0, spam: 0, failed: 0, skipped: 0,
};

export const campaignTotals = (campaign) =>
    (campaign && campaign.totals && typeof campaign.totals === 'object')
        ? { ...EMPTY_TOTALS, ...campaign.totals }
        : { ...EMPTY_TOTALS };

// Open rate over delivered (matches the API's rates.open_rate definition), so
// the list and the detail screen can never disagree about the same number.
export const openRate = (totals) =>
    totals.delivered ? Math.round((totals.opened / totals.delivered) * 1000) / 10 : null;
